import { render, staticRenderFns } from "./ArticleType.vue?vue&type=template&id=416cdbc8&scoped=true&"
import script from "./ArticleType.vue?vue&type=script&lang=js&"
export * from "./ArticleType.vue?vue&type=script&lang=js&"
import style0 from "./ArticleType.vue?vue&type=style&index=0&id=416cdbc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416cdbc8",
  null
  
)

export default component.exports